import { Container } from "@mui/material";
import bgImage from "assets/images/bg-desktop.jpg";
import HomePageLayout from "layouts/components/HomePageLayout";
import MainSection from "layouts/reusable/MainSection";
import { featureMainContent } from "static/homepage/data";

export const Feature = () => {

    const { topic, content, image } = featureMainContent
    return (
        <HomePageLayout
            bgColor={"inherit"}
            image={bgImage}
            pageName="Our Features"
            coverHeight=""
            heroText=""
        >

            <Container>
                <MainSection topic={topic} content={content} image={image} />
            </Container>


        </HomePageLayout>
    );
}

